export default "__VITE_ASSET__cpyj5j3S__"